import { render, staticRenderFns } from "./SetEmailAddressRoute.vue?vue&type=template&id=5ccc55c1"
import script from "./SetEmailAddressRoute.vue?vue&type=script&lang=ts"
export * from "./SetEmailAddressRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports